import React from "react";
import { FieldRendererProps } from "../types";
import { ErrorMessage } from "../styles";
import { SelectMulti } from "../../select-multi";
import { TipoFormulario } from "../../../services/constantes";

export const MultiSelectFieldRenderer: React.FC<FieldRendererProps> = ({
  campo, modo, errors,
}) => (
  <>
    <SelectMulti
      modo={modo || TipoFormulario.tpNenhum}
      dataSource={campo.selectMultiProps?.dataSource || []}
      initialSelected={campo.selectMultiProps?.initialSelected}
      optionLabelField={campo.selectMultiProps?.optionLabelField || ""}
      criticarRepeticao={campo.selectMultiProps?.criticarRepeticao || false}
      onSelectionChange={campo.selectMultiProps?.onSelectionChange || (() => {})}
      orderByField={campo.selectMultiProps?.orderByField}
      maxRecords={campo.selectMultiProps?.maxRecords || 1000}
      optionBackgroundField={campo.selectMultiProps?.optionBackgroundField || '#333'}
      optionTag={campo.selectMultiProps?.optionTag}
      placeholder={campo.selectMultiProps?.placeholder}
      apenasLeitura={campo.apenasLeitura ?? false}
    />
    {errors[campo.nome] && <ErrorMessage>{errors[campo.nome]}</ErrorMessage>}
  </>
);
